import { render, staticRenderFns } from "./ImportacionClientes.vue?vue&type=template&id=224acf16&"
import script from "./ImportacionClientes.vue?vue&type=script&lang=js&"
export * from "./ImportacionClientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports